(function () {
    'use strict';
    angular
        .module('app')
        .directive('editEmail', editEmail);
    editEmail.$inject = ['$window'];
    function editEmail($window) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                editEmailDialogShown: '=?'
            },
            controller: 'editEmails',
            templateUrl: 'app/editEmails/templates/editEmail.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();